import React, { Component } from "react";
import { getproductCategories, getproductCategoryByCategoryId } from "../../constants/prodcutsCategories-constant";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import "./products.css";
import ProductItemGroup from "./ProductItemGroup";
import DropDown from "../../components/dropdown/dropDown";


class Products extends Component {
    state = {
        categories: [],
        dropDownCategories: []
    };

    componentDidMount() {
        const categories = [...getproductCategories()];
        const dropDownCategories = [{ value: "none", label: "تمام دسته بندی ها" }, ...getproductCategories()];
        this.setState({  categories, dropDownCategories });
    }

    handlecategorieselect = category => {
        const selectedCategory = [...getproductCategoryByCategoryId(category.value)];
        this.setState({ categories: selectedCategory });
    };

    render() {
        return (
            <Page>
                <Header />

                <DropDown
                    items={this.state.dropDownCategories}
                    placeholder="تمام دسته بندی ها"
                    onItemSelect={this.handlecategorieselect}
                />
                <section className="container">
                    {this.state.categories.map(categoryItem => (
                        <ProductItemGroup
                            key={categoryItem.key}
                            categoryKey={categoryItem.key}
                            categoryValue={categoryItem.value}
                            categoryLabel={categoryItem.label}
                            categoryDescription={categoryItem.description}
                        />
                    ))}
                </section>
                <Footer />
            </Page>
        );
    }
}

export default Products;
